import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { OnboardingIntentStep } from '../../enums/intent.enum';
import {
  Intent,
  IntentProperties,
  IntentValue,
  UserIntentState,
} from '../../interfaces/intent.interface';
import * as Sentry from '@sentry/angular';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IntentApiService {
  private http = inject(HttpClient);

  fetchIntents() {
    return this.http.get<Intent[]>(`/api/intent/catalogue/intents`);
  }

  getCurrentStateByUserIntentId(userIntentId?: string) {
    return this.http
      .get<
        UserIntentState | IntentValue
      >(`/api/intent/user/intent/${userIntentId || ''}`)
      .pipe(
        tap((state) => Sentry.setContext('INTENT', { 'Intent state': state }))
      );
  }

  updateUserIntent(
    userIntentId: string,
    JumpToState?: OnboardingIntentStep,
    Properties?: IntentProperties
  ) {
    return this.http
      .put<UserIntentState>(`/api/intent/user/intent/${userIntentId}`, {
        JumpToState,
        Properties,
      })
      .pipe(
        tap((state) => Sentry.setContext('INTENT', { 'Intent state': state }))
      );
  }

  createUserIntent(IntentId: string) {
    return this.http.post<{ id: string }>(`/api/intent/user/intent`, {
      IntentId,
    });
  }

  deleteUserIntent(userIntentId: string): Observable<unknown> {
    return this.http.delete<unknown>(`/api/intent/user/intent/${userIntentId}`);
  }
}
